
import { TrimDesigner } from "./TrimDesigner"

export default { TrimDesigner }


export function addTo(el: HTMLElement) {
    let td = new TrimDesigner();
    td.initTrimDesigner(el);
    return td;
}


export function getThumbNailSVG(json) {
    let t = TrimDesigner.CreateThumbNailSVG(json);
    return t;
}


window.onload = function () {
    //  let el = document.getElementById("drawing");
    // if (el != null) {
    //     //let myT = new TrimDesigner(el);
    //     console.log();
    // let myTrim = new TrimDesigner(el);    
    //console.log(new TrimDesigner(el));
    //}
};
